import fileService from '../pages/index/service/file'
import _ from 'lodash'

async function viewDocDetailNew (file, sharePrem, repoType) {
  let fileTmp = _.cloneDeep(file)
  // const { data: fileId } = await fileService.getFileId(file.repoId, file.filePath)
  fileTmp.id = file.fileId
  fileTmp.filePath = fileTmp.filePath.replace(/\/\//, '/')
  fileTmp.filePath = fileTmp.filePath.split('/')
  fileTmp.filePath.splice(0, 1)
  fileTmp.filePath.splice(fileTmp.filePath.length - 1, 1)
  var filePath = []
  for (var i = 0; i < fileTmp.filePath.length; i++) {
    filePath.push({
      name: fileTmp.filePath[i]
    })
  }
  let timestamp = Date.now()
  let sessionValue = JSON.stringify({
    curDoc: fileTmp,
    documents: [fileTmp],
    pathall: filePath,
    repoId: file.repoId,
    sharePrem: sharePrem ? 'yes' : 'no',
    repoType: repoType,
    source: 'task'
  })
  let excel = 0
  let url = `/#/documentation-new/preview/v${timestamp}`
  let fileType = fileTmp.name.substring(fileTmp.name.lastIndexOf('.') + 1) || ''
  fileType = fileType.toLowerCase()
  if (fileType === 'xls' || fileType === 'xlsx') {
    let path = file.filePath
    path = path.startsWith('/') ? path.substr(1) : path
    excel = 1
    if (localStorage.getItem('apiType') === 'baidu') {
      let w = window.open()
      w.sessionStorage.setItem('repoId', fileTmp.repoId)
      w.sessionStorage.setItem('v' + timestamp, sessionValue)
      w.sessionStorage.setItem('excelv' + timestamp, '1')
      w.location = url + '/' + excel
      return
    }
    fileService.viewOnline(path, file.repoId).then((data) => {
      let w = window.open()
      w.sessionStorage.setItem('repoId', fileTmp.repoId)
      w.sessionStorage.setItem('v' + timestamp, sessionValue)
      w.localStorage.setItem('office_access_token', data.access_token)
      w.localStorage.setItem('office_access_token_ttl', data.access_token_ttl)
      w.localStorage.setItem('office_action_url', data.action_url)
      w.sessionStorage.setItem('excelv' + timestamp, '1')
      w.location = url + '/' + excel
    }).catch(() => {
      if (window.rootApp && window.rootApp.$postMessage) {
        window.rootApp.$postMessage.toast({
          msg: '文件预览失败,文件可能移除或者被重名无法生成预览'
        })
      }
    })
  } else {
    let w = window.open()
    w.sessionStorage.setItem('repoId', fileTmp.repoId)
    w.sessionStorage.setItem('v' + timestamp, sessionValue)
    w.location = url + '/' + excel
  }
}

export default {
  preview (file) {
    if (file.matterId) {
      fileService.queryProjectLinkPerm(file.repoId).then(res => {
        if (res.data && res.data[file.repoId]) {
          viewDocDetailNew(file, res.data[file.repoId], 'allowProject')
        } else {
          viewDocDetailNew(file, false, 'allowProject')
        }
      })
    } else {
      viewDocDetailNew(file, true, 'repo')
    }
  },
  queryDocumentType (fileName) {
    let className = ''
    switch (fileName.split('.').pop()) {
      case 'ppt':
        className = 'ibass-filetype-ppt'
        break
      case 'pptx':
        className = 'ibass-filetype-ppt'
        break
      case 'key':
        className = 'ibass-filetype-ppt'
        break
      case 'pdf':
        className = 'ibass-filetype-pdf'
        break
      case 'jpg':
        className = 'ibass-filetype-image'
        break
      case 'jpeg':
        className = 'ibass-filetype-image'
        break
      case 'bmp':
        className = 'ibass-filetype-image'
        break
      case 'gif':
        className = 'ibass-filetype-image'
        break
      case 'png':
        className = 'ibass-filetype-image'
        break
      case 'doc':
        className = 'ibass-filetype-doc'
        break
      case 'docx':
        className = 'ibass-filetype-doc'
        break
      case 'xls':
        className = 'ibass-filetype-excel'
        break
      case 'xlsx':
        className = 'ibass-filetype-excel'
        break
      case 'jar':
        className = 'ibass-filetype-zip'
        break
      case 'zip':
        className = 'ibass-filetype-zip'
        break
      case 'mp3':
        className = 'ibass-filetype-music'
        break
      case 'mp4':
        className = 'ibass-filetype-video'
        break
      default:
        className = 'ibass-filetype-default'
    }
    return className
  }
}
